export default __webpack_public_path__ + "static/media/coffee3.327fc171.jpg";